module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/inner-9-df0058e6e2c267e288ec04a57067307d.jpg";